import { IconCustomers, IconEvents, IconMarketing } from '@components/icons';
import { IconAnalytics, IconInsights, IconOffers } from '@components/icons/src';
import { NavItem } from '@components/layout/src/layout.types';
import {
  ANALYTICS_ROUTE,
  CUSTOMERS_ROUTE,
  EVENT_LIST,
  INSIGHTS_ROUTE,
  MARKETING_ROUTE,
  PRESET_LIST_ROUTE,
} from '@constants/routes';
import { VIEW_UPCOMING } from '@hooks/use-event-navigation/use-event-navigation';
import { getOldNightgraphUrlLanguage } from '@utils/get-old-nightgraph-url-language/get-old-nightgraph-url-language';

export const MAIN_MENU_FIELDS = {
  EVENTS: 'events',
  UPCOMING_EVENTS: 'upcoming',
  PAST_EVENTS: 'past',
  DRAFT_EVENTS: 'draft',
  OFFERS: 'offers',
  CUSTOMERS: 'customers',
  MARKETING: 'marketing',
  ANALYTICS: 'analytics',
  INSIGHTS: 'insights',
};

export const getMainSideBarMenu = ({
  citySlug,
  clubSlug,
  companyId,
  current,
  lang,
  hasBI,
  isDesktop,
  isWebView,
}: {
  clubSlug: string;
  citySlug: string;
  companyId: string;
  current: string;
  lang: string;
  hasBI?: boolean;
  isDesktop?: boolean;
  isWebView?: boolean;
}): NavItem[] => {
  const old_nightgraph_locale = getOldNightgraphUrlLanguage(lang);
  const eventHref = EVENT_LIST.replace(':companyId', companyId)
    .replace(':clubSlug', clubSlug)
    .replace(':view', VIEW_UPCOMING);

  const eventSelected =
    current === MAIN_MENU_FIELDS.EVENTS ||
    current === MAIN_MENU_FIELDS.UPCOMING_EVENTS ||
    current === MAIN_MENU_FIELDS.PAST_EVENTS ||
    current === MAIN_MENU_FIELDS.DRAFT_EVENTS;
  const sidebarMenu: NavItem[] = [];

  if (isDesktop) {
    sidebarMenu.splice(0, 0, {
      name: MAIN_MENU_FIELDS.EVENTS,
      icon: IconEvents,
      href: eventHref,
      current: eventSelected,
      hasCheck: false,
      isDisabled: false,
      isExternalUrl: false,
    });
    sidebarMenu.splice(1, 0, {
      name: MAIN_MENU_FIELDS.ANALYTICS,
      icon: IconAnalytics,
      href: ANALYTICS_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
      current: current === MAIN_MENU_FIELDS.ANALYTICS,
      hasCheck: false,
      isDisabled: false,
      isExternalUrl: false,
    });
  }

  sidebarMenu.splice(2, 0, {
    name: MAIN_MENU_FIELDS.OFFERS,
    icon: IconOffers,
    href: PRESET_LIST_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
    current: current === MAIN_MENU_FIELDS.OFFERS,
    hasCheck: false,
    isDisabled: false,
    isExternalUrl: false,
  });

  if (hasBI) {
    sidebarMenu.splice(isDesktop ? 2 : 0, 0, {
      name: MAIN_MENU_FIELDS.INSIGHTS,
      icon: IconInsights,
      href: INSIGHTS_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
      current: current === MAIN_MENU_FIELDS.INSIGHTS,
      hasCheck: false,
      isDisabled: false,
      isExternalUrl: false,
    });
  }

  if (!isWebView) {
    sidebarMenu.push({
      name: MAIN_MENU_FIELDS.MARKETING,
      icon: IconMarketing,
      href: MARKETING_ROUTE.replace('/:lang', old_nightgraph_locale)
        .replace(':city-slug', citySlug)
        .replace(':companyId', companyId)
        .replace(':club-slug', clubSlug),
      current: current === MAIN_MENU_FIELDS.MARKETING,
      hasCheck: false,
      isDisabled: false,
      isExternalUrl: true,
    });
  }

  sidebarMenu.splice(sidebarMenu.length, 0, {
    name: MAIN_MENU_FIELDS.CUSTOMERS,
    icon: IconCustomers,
    href: CUSTOMERS_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
    current: current === MAIN_MENU_FIELDS.CUSTOMERS,
    hasCheck: false,
    isDisabled: false,
    isExternalUrl: false,
  });

  return sidebarMenu as NavItem[];
};
